var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"outlined":""}},[_c('v-container',[_c('v-data-table',{attrs:{"dense":"","items-per-page":15,"headers":_vm.headers,"items":_vm.confirmed,"hide-default-footer":""},scopedSlots:_vm._u([{key:"item.name",fn:function(ref){
var item = ref.item;
return [_c('div',{domProps:{"innerHTML":_vm._s(_vm.urlTNSObject(item.name))}})]}},{key:"item.disc_internal_name",fn:function(ref){
var item = ref.item;
return [_c('div',{domProps:{"innerHTML":_vm._s(_vm.urlZTFObject(item.disc_internal_name))}})]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }